/**
* 客服系统
*/
<template>
  <div class="wrapper">
    <el-container style="height: 100%;">
      <el-aside width="360px">
        <el-header class="myInfos" height="96px">
          <i class="icon-message">
            <el-image :src="localInfo.user_icon?localInfo.user_icon:'./static/img/Default-avatar.png'" fit="fill">
            </el-image>
          </i>
          <span class="title height40"><span class="over_text_1 inline_block"
              style="max-width: 165px">客服:{{localInfo.user_Name}}</span></span>
          <span class="f14 reconnect color409EFF pointer" v-if="!isConnect&&!isConnecting" @click="getSocketUrl">重新连接</span>
           <span class="f14 reconnect color409EFF pointer" v-if="isConnecting" @click="getSocketUrl">连接中..</span>
          <!-- <a class="eidt">修改展示信息</a> -->
        </el-header>
        <message-group :concats="concats" @switchGroup="switchGroup" />
      </el-aside>
      <el-main style="height: 100%;" v-if="nowSwitchId">
        <el-header class="plbletitle" height="54px" v-if="concats.length>0">
          <!-- <span class="title" v-if="concats[nowSwitch].id == 'group'">聊天室({{lineCount}})人</span> -->
          <span class="title2">与{{concats.length>0?concats[nowSwitch].nick_name:'測試'}}的对话</span>
        </el-header>
        <message-pabel :avatar='avatar' :isRead='isRead' :newMsgs="newMsgs" :concats="concats"
          :nowSwitchId="nowSwitchId" :reload="reload" :localInfo="localInfo" @message="message" />
        <message-input :concats="concats" :localInfo="localInfo" :nowSwitchId="nowSwitchId" />
      </el-main>
      <el-main style="height: 100%; background-color: #F5F7FA; position: relative;" v-else>
        <div class="ct_text">当前还没有客户咨询哦~</div>
      </el-main>
      <audio id="notify-audio">
        <source src="../../assets/wav/tim.mp3" />
      </audio>
    </el-container>
  </div>
</template>

<script>
  import {
    sendWebsocket,
    initWebSocket,
    closeWebsocket,
    getStart,
    getSocketOnError,
    getState
  } from "@/utils/websocket";

  import MessageGroup from '@/components/message-group'
  import MessagePabel from '@/components/message-pabel'
  import MessageInput from '@/components/message-input'
  import {
    list,
    getEmojis,
    chat
  } from '@/api/customer'
  export default {
    data: () => {
      return {
        lineCount: 0,
        concats: [],
        nowSwitch: 0,
        nowSwitchId: '',
        localInfo: {
          user_icon: ''
        },
        reload:false,
        isRead: false,
        avatar: '',
        newMsgs: '', //最新消息
        showBig: false, //图片预览是否显示
        initialIndex: 0, //打开图片预览时候的索引
        isConnecting: false, //连接中
        isConnect: true, //连接状态
        reConnect:false,//重新连接
        timer: null, //3秒检查状态
        showBigImgList: ["url1", "url2", "url3"] //图片的地址
      }
    },
    beforeDestroy() { //订阅事件记得要取消
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      // closeWebsocket();
    },
    mounted() {

    },
    created() {
      this.getSocketUrl();
      // this.load();
    },
    // 注册组件
    components: {
      MessageGroup,
      MessagePabel,
      MessageInput
    },
    methods: {
      load() {
        let that = this;
        let obj = {
          page: 1,
          keyword: '',
          info: ''
        };
        // let loadingInstance = Loading.service({ fullscreen: true });
        list(obj).then(res => {
          if (res.success) {
            let list = res.content.rows;
            console.log(res.content.rows)
            if (list.length > 1) {
              for (let i in list) {
                if (list[i].name === this.nowSwitchId) {
                  that.nowSwitch = i;
                  break;
                }
              }
            }
            that.concats = list;
            console.log(list)
            if (list.length > 0) {
              that.nowSwitchId = list[that.nowSwitch].name;
              that.avatar = list[that.nowSwitch].avatar;
              that.concats[that.nowSwitch].unread = 0;
            }
          } else {
            this.$store.commit('logout', 'false')
            localStorage.setItem('path', '/dashboard/Dashboard')
            this.$router.push({
              path: '/login'
            })
          }
        })
      },
      getSocketUrl() {
        let that = this;
        console.log(getState())
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.load();
        // if (getState() != 1) {
          if(getState() == 1){
              closeWebsocket();
              this.reConnect=true;
          }
          this.isConnecting = true;
          setTimeout(()=>{
            that.isConnecting = false;
          },5000);
          chat().then(res => {
            // let url = 'ws://172.16.9.23:9003';
            let url = process.env.WEBSOCKET_URL;
            this.localInfo = res.content;
            let ws = initWebSocket(url + '/service/ws/cli?sid=' + res.content.sid + '&timestamp=' + res.content
              .timestamp +
              '&sign=' + res.content.sign);
            ws.onmessage = (e) => {
              console.log(e.data);
              // that.newMsgs = e.data;
              that.onMessageWasSent(e.data);
              // global_callback(e.data);
              // reset();
            };
            ws.onopen = () => {
              that.isConnect = true;
              that.isConnecting = false;
              that.reload=true;
              if(!that.reConnect)
              that.$message.success('客服系统已成功连接！');
              getStart();
            };
            ws.onclose = () => {
              that.isConnect = false;
              that.reload=false;
              if(that.isConnecting)
              that.$message.error('客服系统已断开连接！');
            };
            ws.onerror = () => {
              that.isConnect = false;
              that.isConnecting = false;
              getSocketOnError();
            };
            that.onStatus();
          })
        // } else {
        //   chat().then(res => {
        //     this.localInfo = res.content;
        //     that.isConnect = true;
        //     that.onStatus();
        //   })
        // }

      },
      onStatus() {
        let that = this
        this.timer = setTimeout(() => {
          console.log(getState() + '+' + that.isConnect)
          if (getState() == 1) {
            that.isConnect = true;
          }
          if (getState() == 3 && that.isConnect) {
            // that.$message.error('客服系统已断开连接！');
            that.isConnect = false;
          }
          that.onStatus();
        }, 2500)
      },
      onMessageWasSent(message) {
        // 当用户发送消息时调用
        // this.messageList = [...this.messageList, message]
        let that = this
        let body = JSON.parse(message);
        if (body.action_type === 'callback' || body.action_type === 'normal') {
          this.message(body);
        }
        if (body.target_id === this.nowSwitchId && body.action_type === 'callback') {
          this.newMsgs = message;
        }
        if (body.from_id == this.nowSwitchId && body.action_type === 'normal') {
          this.newMsgs = message;
        }
        if (body.from_id == this.nowSwitchId) {
          if (body.action_type === 'command') {
            this.isRead = true;
            setTimeout(() => {
              that.isRead = false;
            }, 500)
          } else {
            this.sendIsRead();
          }
        }

      },
      /**
       * 切换聊天对象
       */
      switchGroup(index, id) {
        if (this.nowSwitchId === id) return
        this.nowSwitchId = id
        this.nowSwitch = index
        this.avatar = this.concats[index].avatar;
        this.isRead = false;
        this.sendIsRead();
        console.log(index, id)
        // 隐藏小红点
        if (this.concats[index].unread !== undefined) {
          // this.concats[index].message.isNewMessage = false
          this.concats[index].unread = 0
        }
      },
      //播放声音
      playSy() {
        let notifyAudio = document.getElementById('notify-audio')
        notifyAudio.play()
      },
      /**
       * 接收消息刷新列表
       */
      message(respone) {
        let concats = this.concats
        let length = concats.length
        let isEit = false;
        let msg = this.msgTips(respone.msg_type, respone.message);
        console.log(respone)
        // 更新联系人消息
        if (respone.from_id === this.nowSwitchId) {
          this.concats[this.nowSwitch].last_msg = msg;
          this.concats[this.nowSwitch].last_time = respone.msg_ctime;
          isEit = true;
        }
        if (!isEit && respone.target_id !== this.nowSwitchId) {
          this.$notify({
            title: '通知',
            dangerouslyUseHTMLString: true,
            message: `
                    <img class="notify-image" width="44" style="border-radius:22px; vertical-align: top; margin-right:10px;" src="${respone.from_avatar}">
                    <span style=" font-size:14px;font-weight:600;height:44px; display:inline-block; line-height:20px;">${respone.from_name}</span>
                    <div class="notify-content">
                      <span><strong> ${msg} </strong</span>
                    </div>
                  `
          })
          this.playSy();
          this.load();
        }
        // this.$forceUpdate()
      },
      editMessage(message) {
        const m = this.messageList.find(m => m.id === message.id);
        m.isEdited = true;
        m.data.text = message.data.text;
      },
      //发送已读
      sendIsRead() {
        let msg = {
          'from_id': this.localInfo.sid,
          'target_id': this.nowSwitchId,
          'action_type': 'command',
          'message': 'readed',
          'commonMessageType': 2171
        };
        sendWebsocket(JSON.stringify(msg));
      },
      //消息转换
      msgTips(msg_type, msg_message) {
        if (msg_type === 'text') {
          let face = msg_message.toString();
          if (face && face.indexOf('[face-') > -1) {
            return '表情';
          } else {
            return msg_message;
          }
        } else if (msg_type === 'image') {
          return '图片消息';
        } else if (msg_type === 'prodUrl') {
          return '产品消息';
        } else if (msg_type === 'file') {
          return '文件消息';
        } else if (msg_type === 'transed') {
          return '转接客服';
        }
      }
    }
  }
</script>

<style scoped>
  .index-main {
    padding: 0 !important;
  }

  .notify-image {
    width: 44px;
    height: 44px;
  }

  .myInfos {
    padding: 20px;
    line-height: 48px;
    border-bottom: 10px solid #f3f3f3;
    position: relative;
  }

  .reconnect {
    position: absolute;
    right: 15px;
    top: 20px;
  }

  .myInfos .icon-message {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    overflow: hidden;
    vertical-align: top;
    border: 2px solid #409EFF;
    margin-right: 5px;
    font-weight: 500;
    background-size: 120%;
  }

  .myInfos .icon-message img {
    width: 48px;
    height: 48px;
  }

  .wrapper {
    background: #fff;
    height: 100%;
  }

  .wrapper .el-container .el-aside,
  .wrapper .el-container .el-main {
    display: flex;
    flex-direction: column;
    padding: 0;
  }

  .wrapper .el-container .el-aside {
    background: #fff;
    border-right: 1px solid #F5F7FA;
  }

  .wrapper .el-container .el-main {
    padding: 0;
    height: 100%;
  }

  .wrapper .el-container .el-header {
    position: relative;
    line-height: 40px;
    overflow: hidden;

  }

  .wrapper .el-container .el-header .title,
  .wrapper .el-container .el-header .icon-message {
    color: #333;
    display: inline-block;
  }

  .wrapper .el-container .el-header .eidt {
    color: #409EFF;
    float: right;
  }

  .wrapper .el-container .el-header .icon-message {
    font-size: 20px;
    vertical-align: top;
  }

  .wrapper .el-container .el-header .title2 {
    display: inline-block;
    margin-left: 5px;
    font-size: 20px;
    color: #333333;
    line-height: 54px;
    letter-spacing: 1px;
    font-weight: 600;
  }

  .wrapper .plbletitle {
    background: #F5F7FA;
    color: #fff;
  }

  .wrapper .footer {
    position: absolute;
    bottom: -23px;
    right: 0;
    left: 0;
    margin: auto;
    font-size: 13px;
    width: 150px;
    color: #ffffff;
    text-align: center;
  }

  .wrapper .footer a {
    color: #ffffff;
  }

  .wrapper .footer a:hover {
    color: #377ec8;
  }

  .ct_text {
    position: absolute;
    left: 50%;
    top: 40%;
    margin-left: -125px;
    width: 250px;
    text-align: center;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #999999;
    z-index: 99;
  }
</style>



// WEBPACK FOOTER //
// src/views/customer/customer.vue